








































import { Vue, Component } from 'vue-property-decorator';

@Component
export default class AdminLayout extends Vue {
  drawer: boolean = true;

  created () {
      this.$vuetify.theme.dark = true
  }

  async signOut() {
    await this.$store.dispatch('$auth/signOut');
  }
}
